import { registerComponent, loading } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "hover-zoom-image",
  class HoverZoomImage extends WYATTElement {
    connectedCallback() {
      if (window.innerWidth < 1024) return;

      this.zoomImage = this.querySelector("[data-zoom-image]");
      this.zoomImageUrl = this.zoomImage.dataset.zoomImage;
      this.setAttribute("data-zoom-image-active", false);

      this.bindEvents();
    }

    bindEvents() {
      this.addEventListener("click", this.handleMouseClick.bind(this), false);

      this.addEventListener(
        "mousemove",
        this.handleMouseMove.bind(this),
        false
      );

      this.addEventListener(
        "mouseleave",
        this.handleMouseLeave.bind(this),
        false
      );
    }

    handleMouseClick() {
      if (this.dataset.zoomImageActive === "true") {
        this.hideZoomImage();
      } else {
        this.showZoomImage();
      }
    }

    handleMouseMove(e) {
      this.moveImage(e);
    }

    handleMouseLeave() {
      this.hideZoomImage();
    }

    showZoomImage() {
      loading.add(this);
      this.zoomImage.style.backgroundImage = `url(${this.zoomImageUrl})`;
      this.zoomImage.style.display = "block";
      this.setAttribute("data-zoom-image-active", true);
    }

    hideZoomImage() {
      loading.remove(this);
      this.zoomImage.style.display = "none";
      this.zoomImage.style.backgroundImage = "";
      this.setAttribute("data-zoom-image-active", false);
    }

    moveImage(e) {
      const dimensions = this.getBoundingClientRect();
      const x = e.clientX - dimensions.left;
      const y = e.clientY - dimensions.top;
      const xPercent = 100 / (dimensions.width / x);
      const yPercent = 100 / (dimensions.height / y);

      this.zoomImage.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
    }
  }
);
